module.exports = __webpack_public_path__ + "static/mongodblab-b49b84c0cf375f0ebbf28e49961b47e1.png";